/*-------------------------------------------
	Homepage Topics
-------------------------------------------*/

Site.modules.Topics = (function($, Site) {

	var $rich;
	var $vanilla;
	var $select;
	var $background;
	var $button;
	var $card;
	var $description;

	function init() {
		$rich = $(".js-topics_rich");

		if ($rich.length) {
			$vanilla = $(".js-topics_vanilla");
			$select = $rich.find(".js-topics_select");
			$background = $rich.find(".js-topic-background");
			$button = $rich.find(".js-topics_button");
			$card = $rich.find(".js-topic_card");
			$description = $rich.find(".js-topics_item_body");
			
			$background.one("loaded.background", onLoad).background();
			setAccessibility();
			$select.dropdown().on("change", onSelectChange);
			$button.on("click", onButtonClick);
			$rich.find(".js-equalize_topic").equalize();
		}
	}

	function onLoad() {
		$rich.addClass("loaded").removeClass("loading");
	}

	function setAccessibility() {
		$rich.attr("aria-hidden", "false").removeAttr("hidden");
		$vanilla.attr("aria-hidden", "true").attr("hidden", "");
	}

	function onButtonClick() {
		var image      = $(this).data("background");
		$background.background("load", image);
		$button.attr("aria-expanded", "false");
		$description.attr("aria-hidden", "true").attr("hidden", "");
		$card.attr("aria-hidden", "true").attr("hidden", "");
		$(".js-topics_button.fs-swap-active")
			.attr("aria-expanded", "true")
			.nextAll(".js-topics_item_body").attr("aria-hidden", "false").removeAttr("hidden");
		$(".js-topic_card.fs-swap-active").attr("aria-hidden", "false").removeAttr("hidden");
	}

	function onSelectChange() {
		var item            = $(".js-topics_select option:selected").data("topic");
		$('[data-topic="' + item + '"]').swap("activate").trigger("click");
	}

	/* Hook Into Main init Routine */

	Site.onInit.push(init);

	return {};
})(jQuery, Site);
